var scope_0 = require('/home/runner/work/talks/talks/2020/0417-design-a-neat-form/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca6f1e266b229a8d5aab88e4afaf1c25.js').default;export default
        Object.assign({}, scope_0 )
    